export const SSO_AUTH_METHOD_KEY = "sso_auth_method" as const;
export type AuthMethod = "SSO" | "PASSWORD";
